import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { StockReplenishmentTemplateFilterLocationModel } from '../../../../../../models/aggregates/erp/stock/stock-replenishment-template-filter-location.model';

@Injectable({ providedIn: 'root' })
export class StockReplenishmentTemplateFilterLocationService extends BaseApiTemplateService<StockReplenishmentTemplateFilterLocationModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-locations/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-locations/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-locations/backoffice-ep';
    this.httpClient = theHttp;
  }

}
